






























import { listFactory } from '@/main/pages';

import { apiProvider } from './api';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	computed: {
		isPracovnikOznDisabled() {
			return !!(this.filter && this.filter.PracovnikOzn);
		},
		isWorkTeamVisible(): boolean {
			return !!this.ProvozovnaId;
		},
	},
	watch: {
		isPracovnikOznDisabled(disabled) {
			if (disabled) {
				this.PracovnikOzn = this.filter.PracovnikOzn;
			}
		},
	},
	methods: {
		async workshopChange(value: any) {
			if (value) {
				this.dropdownList.TympracId = [];
				this.TympracId = null;
				this.startLoading();
				const { data } = await apiProvider.getTeamWorkers(value);
				this.dropdownList.TympracId = data;
				this.endLoading();
			}
		},
	},
});
